export default __webpack_public_path__ + "static/media/moon.c80d6eb0.png";